const workRelation = r => require(["@/views/dashboard/workRelation.vue"], r); // 工联单看板
const workRelationFunction = r => require(["@/views/dashboard/function.vue"], r); // 工联单职能看板
const workWhiteList = r => require(["@/views/dashboard/workWhiteList/searchWhiteList.vue"], r); // 工联单白名单
const worksaveWhite = r => require(["@/views/dashboard/workWhiteList/saveWhite.vue"], r); // 工联单白名单
const workRelationEdit = r => require(["@/views/dashboard/edit.vue"], r); // 工联单看板维护页面
const workFlowDetail = r => require(["@/views/dashboard/workFlowDetail.vue"], r); // 工联单看板流程明细表页面

const trendBoard = r => require(["@/views/dashboard/trend.vue"], r); // 趋势页面
const eachFunctionBoard = r => require(["@/views/dashboard/eachFunction.vue"], r); // 各职能页面
const highFrequencySystem = r => require(["@/views/dashboard/highFrequencySystem.vue"], r); // 职能高频系统看板
const highFrequencyTemplate = r => require(["@/views/dashboard/highFrequencyTemplate.vue"], r); // 各职能页面

export default [
  {
    path: "workRelation",
    component: workRelation,
    name: "workRelation",
    meta: {
      name: "不限制"
    }
  },
  {
    path: "workRelationFunction",
    component: workRelationFunction,
    name: "workRelationFunction",
    meta: {
      name: "不限制"
    }
  },
  {
    path: "workWhiteList",
    component: workWhiteList,
    name: "workWhiteList",
    meta: {
      name: "不限制"
    }
  },
  {
    path: "worksaveWhite",
    component: worksaveWhite,
    name: "worksaveWhite",
    meta: {
      name: "不限制"
    }
  },
  {
    path: "workRelationEdit",
    component: workRelationEdit,
    name: "workRelationEdit",
    meta: {
      name: "不限制"
    }
  },
  {
    path: "workFlowDetail",
    component: workFlowDetail,
    name: "workFlowDetail",
    meta: {
      name: "不限制"
    }
  },
  {
    path: "trendBoard",
    component: trendBoard,
    name: "trendBoard",
    meta: {
      name: "不限制"
    }
  },
  {
    path: "eachFunctionBoard",
    component: eachFunctionBoard,
    name: "eachFunctionBoard",
    meta: {
      name: "不限制"
    }
  },
  {
    path: "highFrequencySystem",
    component: highFrequencySystem,
    name: "highFrequencySystem",
    meta: {
      name: "不限制"
    }
  },
  {
    path: "highFrequencyTemplate",
    component: highFrequencyTemplate,
    name: "highFrequencyTemplate",
    meta: {
      name: "不限制"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/dashboard.js